import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { getDataTypeIcon, getSourceIcon } from './../../../../libs/DataUtilities'

import last from 'lodash/last'

import numeralHinstance from './../../../../libs/numeral'

import './DetailRow.css'

const dataTypeIconStyles = {
    fontSize: 42,
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block'
}

const sourceIconStyle = {
    height: 14,
    marginLeft: 2,
    marginBottom: -3
}

class DetailRow extends Component {

    /* Methods */

    getSourceCssClass = (source) => {
        return `pages-shared-data-visualizer-detail-row pages-shared-data-visualizer-detail-row__${source}`
    }

    /* Handlers */

    /* Lifecycle */
     
    render() {

        const { data_type } = this.props.data
        const { key, value, measure_unit, source } = last(this.props.data.data) || {}

        return (
            <div className={this.getSourceCssClass(source)}>
                <Grid container alignItems="center" justify="center" spacing={16}>
                    
                    <Grid item xs={2}>
                        { getDataTypeIcon(data_type, dataTypeIconStyles) }
                    </Grid>
                    <Grid item xs={10}>
                        <Grid item xs container direction="column" spacing={16}>
                            <Grid item xs>
                                <Typography variant="body2" noWrap>
                                    { this.context.t(`data_types.${data_type}`)}
                                </Typography>
                                <Typography variant="display1" noWrap>
                                    {/*<strong>{value ? numeralHinstance(value).format('0,0[.]0') : '-'}{measure_unit}</strong>*/}
                                    <strong>{value ? value.toLocaleString('it') : '-'}{measure_unit}</strong>
                                </Typography>
                                <Typography variant="caption" noWrap>
                                    {
                                        data_type == "total_attendances_airbnb"
                                            ? <i>stima su dati ufficiali {getSourceIcon(source, sourceIconStyle)}</i>
                                            : <i>fonte ufficiale {getSourceIcon(source, sourceIconStyle)}</i>
                                    }
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                
                </Grid>
            </div>       
        )
    }
}

DetailRow.contextTypes = {
    t: PropTypes.func
}

export default DetailRow


// WEBPACK FOOTER //
// ./src/components/pages/shared/data_visualizer/DetailRow.js